import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faUser, faTicketAlt, faTag, faWallet, faGift, faPlus } from '@fortawesome/free-solid-svg-icons'

const BotonesPos = ({ onClick1, nombre1, onClick2, nombre2, atras, ClienteaFinalizar, onClickDes, onClickObsequio, Obsequio }) => {
	return (
		<React.Fragment>
			<div className="cont_botones_pos">
				<div className="mitad " style={atras ? {} : { display: 'none' }}>
					<button
						style={{marginBottom: 10}}
						onClick={() => ClienteaFinalizar('cliente')}
						className="btn boton_estandar btn-lg gigante btn-block">
						<FontAwesomeIcon icon={faUser} />
					</button>
				</div>
				<div className="mitad" style={atras ? {} : { display: 'none' }}>
					<button
						style={{marginBottom: 10}}
						onClick={onClickDes}
						className="btn boton_estandar btn-lg gigante btn-block">
						<FontAwesomeIcon icon={faTicketAlt} style={{ marginLeft: '-3px' }} />
					</button>
				</div>
				<div className="mitad " style={atras ? {} : { display: 'none' }}>
					<button	
						style={{marginBottom: 10}}
						onClick={onClickObsequio}
						className={`btn boton_estandar btn-lg gigante btn-block  ${Obsequio ? 'border border-secondary' : ''}`}
						title='Obsequio'
					>
						<FontAwesomeIcon icon={faGift} style={{ marginLeft: '-3px' }} />
					</button>
				</div>
				<div className="mitad flex-fill" style={atras ? {} : { width: '45%' }}>
					<button
						style={{marginBottom: 10}}
						onClick={onClick1}
						className="btn boton_estandar btn-lg gigante btn-block">
						{nombre1}
						<FontAwesomeIcon icon={faPlus} style={{ marginLeft: '-3px', marginLeft: 5 }} />
					</button>
				</div>
				<div className="mitad flex-fill" style={atras ? {} : { width: '45%' }}>
					<button
						style={{marginBottom: 10}}
						onClick={onClick2}
						className="btn boton_estandar btn-lg gigante btn-block"
					>{nombre2}
					</button>
				</div>

			</div>
		</React.Fragment >
	)
}



export default BotonesPos